import { z } from "zod";

const booleanFromString = z
	.union([z.boolean(), z.enum(["true", "false"]).transform((value) => value === "true")])
	.default(false);

export const loginSearchSchema = z.object({
	error: z.string().optional(),
	code: z.string().optional(),
	state: z.string().optional(),
});

export const transactionsSearchSchema = z.object({
	page: z.coerce.number().default(1),
	startDate: z.string().optional(),
	endDate: z.string().optional(),
	locationId: z.string().optional(),
});

export const pricingSearchSchema = z.object({
	manualIdentification: booleanFromString,
});

export type LoginSearch = z.infer<typeof loginSearchSchema>;
export type TransactionsSearch = z.infer<typeof transactionsSearchSchema>;
export type PricingSearch = z.infer<typeof pricingSearchSchema>;
